"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineActions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _utils = require("../../lib/utils");
var _styles = require("../styles");
const propTypes = {
  displayLinkToViewMoreAvailabilities: _propTypes.bool.isRequired,
  linkTarget: _propTypes.string,
  moreAvailabilitiesLinkText: _propTypes.node,
  onViewMoreClick: _propTypes.func,
  providerId: _propTypes.number.isRequired,
  shouldDisplayAsOnMobile: _propTypes.bool,
  shouldRenderSlotsAsButtons: _propTypes.bool,
  viewMoreAriaLabel: _propTypes.string,
  viewMoreBookOnlineUrl: _propTypes.string
};
const defaultProps = {
  onTimeSlotsClick: () => {},
  shouldDisplayAsOnMobile: false,
  shouldRenderSlotsAsButtons: false
};
const InlineActions = _ref => {
  let {
    displayLinkToViewMoreAvailabilities,
    linkTarget,
    moreAvailabilitiesLinkText,
    onViewMoreClick,
    providerId,
    shouldDisplayAsOnMobile,
    shouldRenderSlotsAsButtons,
    viewMoreAriaLabel,
    viewMoreBookOnlineUrl
  } = _ref;
  const showViewMore = displayLinkToViewMoreAvailabilities && viewMoreBookOnlineUrl;
  if (!showViewMore) {
    return null;
  }
  let viewMoreActionProps = {};
  if (!shouldRenderSlotsAsButtons) {
    viewMoreActionProps = {
      href: viewMoreBookOnlineUrl,
      target: linkTarget,
      rel: (0, _utils.getLinkRel)(linkTarget)
    };
  }
  return /*#__PURE__*/_react.default.createElement(_styles.InlineSlot, (0, _extends2.default)({
    as: shouldRenderSlotsAsButtons ? 'button' : 'a',
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    "aria-label": viewMoreAriaLabel,
    onClick: () => onViewMoreClick(providerId, viewMoreBookOnlineUrl)
  }, viewMoreActionProps), moreAvailabilitiesLinkText);
};
exports.InlineActions = InlineActions;
InlineActions.propTypes = propTypes;
InlineActions.defaultProps = defaultProps;
InlineActions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InlineActions",
  "props": {
    "onTimeSlotsClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "shouldDisplayAsOnMobile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "shouldRenderSlotsAsButtons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "displayLinkToViewMoreAvailabilities": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "linkTarget": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "moreAvailabilitiesLinkText": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onViewMoreClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "viewMoreAriaLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "viewMoreBookOnlineUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};